import { cn } from '@/lib/utils';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { OrganizationRegistrationFieldProps } from './types';
import { Textarea } from '@/components/ui/textarea';

const OrganizationRegistrationField = (props: OrganizationRegistrationFieldProps) => {
  const {
    disabled,
    error,
    helperText,
    id,
    inputMode,
    isMultiline,
    label,
    onBlur,
    onChange,
    rightIcon,
    value
  } = props;

  return (
    <div className="flex flex-col gap-2">
      <Label
        className="text-sm font-semibold leading-5 text-muted-foreground"
        htmlFor={id}
      >
        {label}
      </Label>
      {isMultiline ? (
        <Textarea
          className={cn(
            'min-h-[64px] px-4 py-3',
            'rounded-2xl bg-surface',
            error && 'border-destructive ring-1 ring-destructive'
          )}
          disabled={disabled}
          id={id}
          onBlur={onBlur}
          onChange={(event) => onChange(event.target.value)}
          rows={2}
          value={value}
        />
      ) : (
        <Input
          disabled={disabled}
          error={Boolean(error)}
          id={id}
          inputMode={inputMode}
          onBlur={onBlur}
          onChange={(event) => onChange(event.target.value)}
          rightIcon={rightIcon}
          value={value}
        />
      )}
      {error ? <p className="px-3 text-xs text-[hsl(var(--error-text))]">{error}</p> : null}
      {!error && helperText ? <p className="px-3 text-xs text-muted-foreground">{helperText}</p> : null}
    </div>
  );
};

export default OrganizationRegistrationField;